const RECURRENCE_RULE_PARSE_TYPE = Object.freeze({
  mm: 'millarm',
  normal: 'normal',
});

export default RECURRENCE_RULE_PARSE_TYPE;
